<template>
  <div v-loading="loading">
    <el-table
      :key="tableKey"
      :data="patterns"
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="#"
        width="50"
      />
      <el-table-column
        label="Megnevezés"
        show-tooltip-when-overflow=""
      >
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column
        label="Ismétlődés"
      >
        <template slot-scope="scope">
          {{ scope.row.interval }} {{ getIntervalType(scope.row.interval_type) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="subscribers"
        sortable
        label="Feliratkozók"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tooltip placement="top" style="max-width: 300px;" popper-class="permission-info-tooltip">
            <div slot="content">
              <span v-if="scope.row.subscribers.length">{{ scope.row.subscribers.map(p => p.last_name +' '+ p.first_name).join(', ') }}</span>
              <span v-if="!scope.row.subscribers.length">Nem tartozik feliratkozó ehhez a feladathoz</span>
            </div>
            <el-tag v-if="scope.row.subscribers.length"> {{ scope.row.subscribers.length }} feliratkozó</el-tag>
            <el-tag type="danger" v-if="!scope.row.subscribers.length">Nincs feliratkozó</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <Actions :pattern="scope.row" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';

  export default {
    components: {
      Actions,
    },
    data() {
      return {
        tableKey: 0,
      };
    },
    computed: {
      patterns() {
        return this.$store.getters['todoRecurringPattern/patterns'];
      },
      loading() {
        return this.$store.getters['todoRecurringPattern/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    methods: {
      getIntervalType(type) {
        switch (type) {
          case 'day':
            return 'naponta';
          case 'week':
            return 'hetente';
          case 'month':
            return 'havonta';
          case 'year':
            return 'évente';
        }
      },
      getCreateType(type) {
        switch (type) {
          case 'minute':
            return 'perccel';
          case 'hour':
            return 'órával';
          case 'day':
            return 'nappal';
          case 'week':
            return 'héttel';
          case 'month':
            return 'hónappal';
          case 'year':
            return 'évvel';
        }
      },
    },
    async mounted() {
      await this.$store.dispatch('todoRecurringPattern/fetchAll');
    },
  };
</script>
